import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// antd
import { Spin, Typography, theme } from 'antd'

// slices
import { projectReportsState } from '../projectReports/projectReports.slice'
import { screenshotsGet, screenshotsState } from './screenshots.slice'

// assets
import { NoScreenshotsIcon } from '../../../assets/icons'
import { ScreenShotComponent } from './ScreenShotComponent'

const ScreenShotsPage = () => {
    const { Title, Text } = Typography

    const { useToken } = theme

    const { token } = useToken()

    const dispatch = useDispatch()

    const { screenshotsData, status, userChangeName } =
        useSelector(screenshotsState)

    const { filter, dateRanges } = useSelector(projectReportsState)

    async function DateRangeSet() {
        if (dateRanges?.start && dateRanges?.end) {
            const dataScreen = {
                start: dateRanges?.start,
                end: dateRanges?.end,
                projectId: filter?.projectId,
                assigneeId: filter?.assigneeId,
            }
            dispatch(screenshotsGet(dataScreen))
        }
    }

    useEffect(() => {
        DateRangeSet()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dateRanges, userChangeName, filter])

    return (
        <>
            {status === 'loading' ? (
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: '120px',
                    }}
                >
                    <Spin spinning={true} />
                </div>
            ) : screenshotsData?.data &&
              Object.keys(screenshotsData?.data)?.length > 0 &&
              status === 'loaded' ? (
                // ScreenShotComponent()
                <ScreenShotComponent
                    screenshotsData={screenshotsData}
                    token={token}
                />
            ) : (
                screenshotsData?.data &&
                Object.keys(screenshotsData?.data)?.length === 0 && (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: '120px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                            }}
                        >
                            <div
                                style={{
                                    width: '400px',
                                }}
                            >
                                <NoScreenshotsIcon />
                            </div>
                        </div>
                        <Text
                            className="titleSecondary"
                            style={{
                                marginTop: '20px',
                            }}
                        >
                            No Screenshots Found yet.
                        </Text>
                    </div>
                )
            )}
        </>
    )
}

export default ScreenShotsPage
